/**
 * Servicio para gestión de simulaciones del profesor
 */

import {
  EstadisticasAlumno,
  EstadisticasSimulaciones,
  FiltrosSimulaciones,
  SimulacionProfesor,
} from "../../app/profesor/simulaciones/dto/simulaciones.dto";
import { apiClientWeb } from "../../lib/apiClientWeb";

export const simulacionesProfesorService = {
  /**
   * Obtiene todas las simulaciones de los alumnos del profesor
   */
  getSimulaciones: async (
    filters?: FiltrosSimulaciones
  ): Promise<SimulacionProfesor[]> => {
    const params = new URLSearchParams();
    if (filters?.alumnoId) {
      params.append("alumnoId", filters.alumnoId.toString());
    }
    if (filters?.fechaDesde) {
      params.append("fechaDesde", filters.fechaDesde);
    }
    if (filters?.fechaHasta) {
      params.append("fechaHasta", filters.fechaHasta);
    }
    if (filters?.estado) {
      params.append("estado", filters.estado);
    }

    const queryString = params.toString();
    const url = `/api/profesor/simulaciones${
      queryString ? `?${queryString}` : ""
    }`;

    const response = await apiClientWeb.get(url);
    return response.data.data;
  },

  /**
   * Obtiene estadísticas generales de simulaciones
   */
  getEstadisticas: async (): Promise<EstadisticasSimulaciones> => {
    const response = await apiClientWeb.get(
      "/api/profesor/simulaciones/estadisticas"
    );
    return response.data.data;
  },

  /**
   * Obtiene estadísticas detalladas de un alumno específico
   */
  getEstadisticasAlumno: async (
    alumnoId: number
  ): Promise<EstadisticasAlumno> => {
    const response = await apiClientWeb.get(
      `/api/profesor/simulaciones/alumno/${alumnoId}`
    );
    return response.data.data;
  },
};
